import type { NativeJourney } from "../shared/native-bridge";

export interface ActivityTelemetryMark { key: string; atMs: number }

export function activityTelemetryMark(last: ActivityTelemetryMark | null, journey: NativeJourney, planId: string | null, nowMs: number): ActivityTelemetryMark | null {
	const key = JSON.stringify([planId, journey.activityKey, journey.dayKey, journey.direction, journey.phase, journey.lead, journey.detail, journey.note, journey.tone]);
	return last?.key !== key || nowMs - last.atMs >= 30_000 ? { key, atMs: nowMs } : null;
}